import {useNavigate} from "react-router-dom";
import EnlilAxios from "../../util/EnlilAxios";
import {useEffect} from "react";
import MemoryContext from "../../util/MemoryContext";
import {SessionContext} from "../../util/SessionContext";
import EventBus from "../../util/EventBus";

export default function Logout() {

    const navigate = useNavigate();

    useEffect(() => {

        let sessionContext = new SessionContext();
        let sid: string | null = sessionContext.getSID();

        sessionStorage.clear();

        MemoryContext.components = {}

        // @ts-ignore
        EventBus.session.emit("update");

        // @ts-ignore
        EnlilAxios({
            method: "POST",
            url: "t8/v1/logout",
            json: true,
            data: {
                sid: sid
            }
        }).then(response => {
            console.log(response);
        }).catch(error => {
            console.log(error);
        });

        navigate("/", {replace: true});

    }, [navigate]);

    return null;
}
